import { render, staticRenderFns } from "./ElectricityTariffForm.vue?vue&type=template&id=25d6629a"
import script from "./ElectricityTariffForm.vue?vue&type=script&lang=js"
export * from "./ElectricityTariffForm.vue?vue&type=script&lang=js"
import style0 from "./ElectricityTariffForm.vue?vue&type=style&index=0&id=25d6629a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports